<template>
    <div >
        Great news! Your switch <span v-if="supplier">to <b>{{ supplier.name }}</b> at {{ currentPropertyAddress }}</span> is complete.
    </div>
</template>

<script>
import api from "@/utils/api";

export default {
    name: "SwitchCompleted",
    props: {
        notification: Object
    },
    data() {
        return {
            supplier: null,
            currentPropertyAddress: null
        }
    },
    mounted() {
        let that = this;
        api.getRecommendation(this.notification.payload.recommendation_id, {
            recommendations: {fields: ['product','property']},
            products: {fields: ['supplier']},
            supplier: {fields: ['name']},
            properties: {fields: ['currentPropertyAddress']}
        }).then(response => {
            that.supplier = response.data.data.product.supplier
            that.currentPropertyAddress = response.data.data.property.currentPropertyAddress
        })
    }
}
</script>

<style scoped>

</style>
